import {reduxForm, change } from "redux-form";
import { fetchReasons, createReason, editReason, deleteReason, selectReason, resetCurrentReason } from "../../actions/adjustmentInventory_actions";
import {connect} from 'react-redux';
import AdjustmentInventory from '../../components/Inventories/adjustmentInventory';

const adjustmentInventory = reduxForm({
    form: 'adjustmentInventory',
})(AdjustmentInventory);

function mapStateToProps(state) {
    return {
        reasons: state.adjustment.reasons,
        isEditing: state.adjustment.isEditing,
        isLoading: state.adjustment.isLoading,
        isDeleting: state.adjustment.isDeleting,
        createError: state.adjustment.createError,
        editingError: state.adjustment.editingError,
        deletionError: state.adjustment.deletionError,
        edited: state.adjustment.edited,
        created: state.adjustment.created,
        deleted: state.adjustment.deleted,
        error: state.adjustment.error,
        reason: state.adjustment.reason
    }
}

export default connect(mapStateToProps, {
    fetchReasons,
    createReason,
    deleteReason,
    editReason,
    selectReason,
    resetCurrentReason,
})(adjustmentInventory);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/adjustmentInventory.jsx